<template>
  <div class="relative flex min-h-dvh w-full flex-col">
    <div class="sticky top-0 z-50 shrink-0">
      <slot name="header" />
    </div>
    <div class="w-full grow flex flex-col" :class="[!fullWidth && 'mx-auto max-w-4xl']">
      <slot />
    </div>
    <div class="fixed bottom-0 z-10 w-full" v-if="hasFooterSlot">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  fullWidth?: boolean
}

defineProps<Props>()
import { useSlots } from 'vue'

const slots = useSlots()
const hasFooterSlot = !!slots.footer
</script>
